import nbcCardRedirect from '@/forms/components/shared/nbc-card-redirect';

export default nbcCardRedirect({ rewardType: 'Miles Up for travel rewards' });
